let apiaddress = 'https://uat-api.mc869m8.com';

switch (process.env.VUE_APP_MODE) {
  case 'uat':
    apiaddress = 'https://uat-api.mc869m8.com';
    break;
  case 'production':
    apiaddress = 'https://api.h8k6dda.com';
    break;
}

export default apiaddress;
